var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{directives:[{name:"icon",rawName:"v-icon",value:(['carrierTypeConvert', _vm.model.type + 1]),expression:"['carrierTypeConvert', model.type + 1]"}]}),_vm._v(" "+_vm._s(_vm.model[_vm.index])+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }